// eslint-disable-next-line import/no-extraneous-dependencies
import Papa from 'papaparse'

const csvToJson = (csvString: string): { data: Record<string, any>[], error?: string } => {
    const result = Papa.parse(csvString, {
        header: true,
        skipEmptyLines: true,
        dynamicTyping: true,
        transformHeader: (header: string) => {
            return header.trim()
        },
    })

    if (result.errors.length > 0) {
        return {
            data: [],
            error: result.errors[0].message,
        }
    }

    return {
        data: result.data as Record<string, any>[],
    }
}

export default csvToJson
